/**
 * Photo attribution line — none on this site. Every Verde Vercelli photo and
 * reel is own work (spec §9.2, media/credits.json: all rights reserved, no
 * licence to cite), so there is nothing to print next to a photo; the full
 * list stays on the credits page. Kept, rendering nothing, so the call sites
 * copied from the sister site (ServicesMenu, service pages) compile as they are.
 */
export function Credit(_: { role: string }) {
  return null
}
